import { RootState } from "../../typescript/redux";

export const getState = (state: RootState) => state.users;

export const getUsers = (state: RootState) => state.users.list;
